import React, { useContext } from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import TextLink from '@components/shared/TextLink';
import { HAMBURGER_BREAKPOINT } from '@constants';
import { NavBarCategory, NavStatus } from '@contracts';
import { NavContext } from './Context';
import NavBarNewBadge from './NavBarNewBadge';

interface NavBarLinkProps {
  navbarLink?: string;
  category?: NavBarCategory;
  text: string;
  isNew?: boolean;
}

const NavBarLink: React.FC<NavBarLinkProps> = ({ category, navbarLink, text, isNew }) => {
  const { navState, navDispatch } = useContext(NavContext);
  const { navbarSelectedCategories, navbarItemColor } = navState;
  const isSelectedCategory = !!navbarSelectedCategories?.length && navbarSelectedCategories[navbarSelectedCategories.length - 1] === category;
  const isExternalLink = navbarLink && navbarLink.startsWith('http');
  const isSelected = isSelectedCategory;

  return (
    <Wrapper $isSelected={isSelected} $color={navbarItemColor}>
      <TextLinkWrapper>
        <TextLink
          target={isExternalLink ? '_blank' : undefined}
          rel={isExternalLink ? 'noreferrer' : undefined}
          $color={navbarItemColor}
          to={navbarLink || '#'}
          onMouseEnter={() => {
            if (category) {
              if (!navbarSelectedCategories.includes(category)) {
                navDispatch({ type: 'setStatus', data: NavStatus.Menu });
                navDispatch({ type: 'removeNavbarSelectedCategories', data: category });
              }
            }
          }}
          onClick={(e) => {
            if (!navbarLink) {
              e.preventDefault();
            }

            if (category) {
              if (!navbarSelectedCategories.includes(category)) {
                navDispatch({ type: 'setStatus', data: NavStatus.Menu });
                navDispatch({ type: 'removeNavbarSelectedCategories', data: category });
              }
            }
          }}
        >
          {text}
        </TextLink>
        <NavBarNewBadge isNew={isNew} />
      </TextLinkWrapper>
      {isSelected ? <SelectedLine /> : null}
    </Wrapper>
  );
};

export default NavBarLink;

const Wrapper = styled.div<{ $isSelected?: boolean; $color?: string }>`
  position: relative;

  a {
    color: ${Colors.navyBlue};
    white-space: nowrap;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: BrownStd;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    border-bottom: none;

    ${({ $isSelected }) => ($isSelected ? `font-weight: 700; ` : null)}
  }
`;

const TextLinkWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  height: 26px;
`;

const SelectedLine = styled.div`
  width: 100%;
  border: 1px solid ${Colors.ecru};
  position: absolute;
  top: 46px;
`;

export const NavBarLinksWrap = styled.div`
  gap: 30px;
  display: flex;

  @media (max-width: ${HAMBURGER_BREAKPOINT + 150}px) {
    gap: 20px;
  }

  @media (max-width: ${HAMBURGER_BREAKPOINT}px) {
    display: none;
  }
`;
